/**
 * Refresh freezes have been removed platform-wide. A refresh always recomputes
 * and updates a company's data, so nothing is ever considered frozen. These
 * helpers are kept as no-ops so existing callers don't need to change.
 */

// Always false — no company is frozen anymore.
export const isRefreshFrozen = () => false;

// Never blocks — a refresh always proceeds.
export const getFreezeMessage = () => null;
